module.exports = __webpack_public_path__ + "static/32ad03aed89ef33785683c8113185ab3.svg";